import { delayCallback } from '../helpers/delayNavigate';
import {
  IFunctionDeleteForm,
  IFunctionSubmitForm,
} from '../interfaces/common.interface';

export const handleSubmitForm = async ({delayWhenCancel = 1000, ...props}: IFunctionSubmitForm) => {
  props.callback();
  const extraValidateResult = props.extraValidate
    ? props.extraValidate()
    : true;
  const resultValidate = props.requiredKeys
    ? props.requiredKeys.every((key: string) => !!props.data[key])
    : true;
  if (resultValidate && extraValidateResult) {
    props.setLoading(true);
    try {
      !props.id
        ? await props.asyncFunc(props.data)
        : await props.asyncFunc(props.data, props.id);
      props.toggleSuccessModalNoti();
      delayWhenCancel
        ? delayCallback(() => props.formCancelCallBack(true), delayWhenCancel)
        : props.formCancelCallBack(true);
    } catch (error) {
      props.toggleErrorModalNoti();
    }
    props.setLoading(false);
  }
};

export const handleDeleteForm = async ({delayWhenCancel = 1000, ...props}: IFunctionDeleteForm) => {
  props.callback();
  if (!props.runAsyncFunc) {
    props.handleResetForm();
  } else {
    props.setLoading(true);
    try {
      await props.asyncFunc(props.id);
      props.handleResetForm();
      props.toggleSuccessModalNoti();
      delayWhenCancel
        ? delayCallback(() => props.formCancelCallBack(true), delayWhenCancel)
        : props.formCancelCallBack(true);
    } catch (error) {
      props.toggleErrorModalNoti();
    }
    props.setLoading(false);
  }
};

export const handleResetForm = ({
  setValueState,
  setErrorState,
  initValueState,
  initErrorState,
}: {
  setValueState: any;
  setErrorState?: any;
  initValueState: any;
  initErrorState?: any;
}) => {
  setValueState(initValueState);
  setErrorState && setErrorState(initErrorState);
};
